import * as types from "../../constants";
import { clearPatientsStore } from "../../db";
import {
  signIn as authSignIn,
  signUp as authSignUp,
  resetPassword as authResetPassword,
} from "../../services/authService";
import { clearSession } from "../../services/sessionLifecycle";
import { addBreadcrumb } from "../../utils/diagnostics/breadcrumbs";

export function signIn(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return authSignIn(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function signUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authSignUp(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_UP_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

export function signOut() {
  return async (dispatch) => {
    // Capture a short stack trace so the next time AUTH_SIGN_OUT fires
    // unexpectedly (as observed in the ATTADIR chom-dakar session), the
    // diagnostic breadcrumbs tell us which caller triggered it, not just
    // that the reducer ran.
    try {
      const stack = new Error('signOut.dispatch').stack || '';
      const shortStack = stack.split('\n').slice(1, 6).join(' | ');
      addBreadcrumb('state', 'auth.signOut.dispatched', {
        route: typeof window !== 'undefined' ? window.location?.pathname : undefined,
        errorMessage: shortStack.slice(0, 400),
      });
    } catch (_) { /* never break sign-out */ }
    // SHER-215 — drop axios's default Authorization header *before* awaiting
    // clearPatientsStore so any pagination/sync that fires during the await
    // can't carry the previous user's JWT into a fresh request.
    clearSession();
    await clearPatientsStore();
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}

export function resetPassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authResetPassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}
